import React from "react";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import EnqueryModal from "./EnqueryModal";
import "./header.css";
const WebsiteHeader = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleDropdown = (name) => {
    setActiveDropdown(activeDropdown === name ? null : name);
  };

  const serviceClick = () => {
    setActiveDropdown(null);
  };
  return (
    <>
      <header className={`header-two header--sticky`}>
        {/* header-top remains unchanged */}
        <div className="header-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="header-top-wrapper">
                  <div className="left">
                    <div className="call">
                      <i className="fa-light fa-mobile"></i>
                      <a href="tel:+91 8600082700" style={{ lineHeight: 1.5 }}>
                        +91 8600082700
                      </a>
                    </div>
                    <div class="call">
                      <i class="fa-solid fa-envelope"></i>
                      <a href="mailto:info@technolandsurvey.com">
                        info@technolandsurvey.com
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="social-header">
                      <ul class="social-icons">
                        <li>
                          <a href=" https://www.facebook.com/technolandengineers/">
                            <i class="fa-brands fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://x.com/engineers20359 ">
                            <i class="fa-brands fa-x"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/technoland_surveyors/">
                            <i class="fa-brands fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.linkedin.com/company/techno-land-engineers-and-surveyors/">
                            <i class="fa-brands fa-linkedin-in"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* header main section */}
        <div className="header-two-main-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="header-two-wrapper">
                  <Link className="logo-area" to="/">
                    <img src="/assets/images/about/redlogo.png" alt="logo" />
                  </Link>

                  {/* Desktop Menu */}
                  <div className="nav-area ms-auto d-none d-lg-block">
                    <ul>
                      <li
                        className={`main-nav ms-2 ${
                          currentPath === "/" ? "active" : ""
                        }`}
                      >
                        <Link to="/">Home</Link>
                      </li>
                      <li
                        className={`main-nav ms-2 ${
                          currentPath === "/about-us" ? "active" : ""
                        }`}
                      >
                        <Link to="/about-us">About Us</Link>
                      </li>
                      <li
                        className={`main-nav ms-2 ${
                          currentPath === "/project" ? "active" : ""
                        }`}
                      >
                        <Link to="/project">Projects</Link>
                      </li>
                      <li
                        className="main-nav ms-2 has-dropdown me-3"
                        onMouseEnter={() => setActiveDropdown("services")}
                        onMouseLeave={() => setActiveDropdown(null)}
                      >
                        <Link>Services</Link>

                        <ul
                          className={`submenu submenu-grid ${
                            activeDropdown === "services" ? "show" : ""
                          }`}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr", // two equal columns
                            gap: "8px 30px", // adjust vertical and horizontal spacing
                            listStyle: "none",
                          }}
                        >
                          <li>
                            <Link
                              onClick={() => setActiveDropdown(null)}
                              to="/land-survey"
                            >
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Land Survey
                            </Link>
                          </li>
                          <li>
                            <Link to="/water-supply">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Water Supply
                            </Link>
                          </li>
                          <li>
                            <Link to="/sewerage-system">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Sewerage System
                            </Link>
                          </li>
                          <li>
                            <Link to="/drainage-system">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Drainage System
                            </Link>
                          </li>
                          <li>
                            <Link to="/rain-water-harvesting">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Rain Water Harvesting
                            </Link>
                          </li>
                          <li>
                            <Link to="/irrigation-system">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Irrigation System
                            </Link>
                          </li>
                          <li>
                            <Link to="/road-survey">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Road’s
                            </Link>
                          </li>
                          <li>
                            <Link to="/property-tax-survey">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Property Tax Survey
                            </Link>
                          </li>

                          <li>
                            <Link to="/soil-investigation">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Soil Investigation
                            </Link>
                          </li>
                          <li>
                            <Link to="/property-liaising">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Property Liaisoning
                            </Link>
                          </li>
                          <li>
                            <Link to="/property-valuation">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Property Valuation
                            </Link>
                          </li>
                          <li>
                            <Link to="/biometric-survey">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Biometric Survey{" "}
                            </Link>
                          </li>
                          <li>
                            <Link to="/underground-water-survey">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Underground Water Survey
                            </Link>
                          </li>
                          <li>
                            <Link to="/aerial-surey">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Aerial Survey
                            </Link>
                          </li>
                          <li>
                            <Link to="/airport-noc">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Airport Noc
                            </Link>
                          </li>
                          <li>
                            <Link to="/traffic-simulation-survey">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Traffic Simulation & Survey{" "}
                            </Link>
                          </li>
                          <li>
                            <Link to="/society-maintenance">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Company/ Society Maintenance Service Division
                            </Link>
                          </li>
                          <li>
                            <Link to="/civil-maintenance-software">
                              <span style={{ marginRight: "10px" }}>➤ </span>{" "}
                              Technoland’s Civil Maintenance Software
                            </Link>
                          </li>
                        </ul>
                      </li>
                      {/* <li
                        className={`main-nav ms-2 ${
                          currentPath === "/our-technologies" ? "active" : ""
                        }`}
                      >
                        <Link to="/our-technologies">Our Technologies</Link>
                      </li> */}
                      {/* <li
                        className={`main-nav ms-2 ${
                          currentPath === "/gallery" ? "active" : ""
                        }`}
                      >
                        <Link to="/gallery">Gallery</Link>
                      </li> */}
                      <li
                        className={`main-nav ms-2 ${
                          currentPath === "/career" ? "active" : ""
                        }`}
                      >
                        <Link to="/career">Career</Link>
                      </li>
                      <li
                        className={`main-nav ms-2 ${
                          currentPath === "/blogs" ? "active" : ""
                        }`}
                      >
                        <Link to="/blogs">Blogs</Link>
                      </li>
                    </ul>
                  </div>

                  {/* Mobile Menu Toggle */}
                  <div className="header-end ms-5">
                    <Link
                      to="/contact-us"
                      className="rts-btn btn-primary hide-contact-us"
                      style={{ padding: "10px 19px" }}
                    >
                      Contact us
                    </Link>

                    <div
                      className="nav-btn menu-btn d-lg-none"
                      onClick={() => setMenuOpen(true)}
                    >
                      <img src="/assets/images/logo/bar.svg" alt="menu" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Slide Menu */}
        <div className={`mobile-menu-wrapper ${menuOpen ? "active" : ""}`}>
          <div className="mobile-menu-content">
            <button className="close-btn" onClick={() => setMenuOpen(false)}>
              ✕
            </button>
            <ul className="mobile-nav">
              <li>
                <Link to="/" onClick={() => setMenuOpen(false)}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about-us" onClick={() => setMenuOpen(false)}>
                  About Us
                </Link>
              </li>
              <li>
                <div
                  onClick={() => toggleDropdown("services")}
                  className="mobile-dropdown-toggle"
                >
                  Services{" "}
                  <span>{activeDropdown === "services" ? "▲" : "▼"}</span>
                </div>
                {activeDropdown === "services" && (
                  <ul className="mobile-submenu">
                    <li>
                      <Link
                        to="/land-survey"
                        onClick={() => setMenuOpen(false)}
                      >
                        Land Survey
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/water-supply"
                        onClick={() => setMenuOpen(false)}
                      >
                        Water Supply
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/sewerage-system"
                      >
                        Sewerage System
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/drainage-system"
                      >
                        Drainage System
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/rain-water-harvesting"
                      >
                        Rain water Harvesting
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/irrigation-system"
                      >
                        Irrigation System
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/road-survey"
                      >
                        Road Survey
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/property-tax-survey"
                      >
                        Property Tax Survey
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/society-maintenance"
                      >
                        Company/ Society Maintenance Service Division
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/soil-investigation"
                      >
                        Soil Investigation
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/property-liaising"
                      >
                        Property Liaisoning
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/property-valuation"
                      >
                        Property Valuation
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <Link to="/project" onClick={() => setMenuOpen(false)}>
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/our-technologies" onClick={() => setMenuOpen(false)}>
                  Our Technologies
                </Link>
              </li>
              {/* <li>
                <Link to="/gallery" onClick={() => setMenuOpen(false)}>
                  Gallery
                </Link>
              </li> */}
              <li>
                <Link to="/career" onClick={() => setMenuOpen(false)}>
                  Career
                </Link>
              </li>
              <li>
                <Link to="/blogs" onClick={() => setMenuOpen(false)}>
                  Blogs 
                </Link>
              </li>
              <li>
                <Link to="/contact-us" onClick={() => setMenuOpen(false)}>
                  Contact Us
                </Link>
              </li>
            </ul>

            <div className="mobile-social-icons">
              <a href="#">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-twitter"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-whatsapp"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default WebsiteHeader;
